"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _lodash = _interopRequireDefault(require("lodash"));

var _ApiRequest = _interopRequireDefault(require("./ApiRequest"));

var _ApiRequestsCollection = _interopRequireDefault(require("./ApiRequestsCollection"));

var _DevTools = _interopRequireDefault(require("../utils/DevTools"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

/**
 * Utility chain for talking to the server
 *
 * Copyright (C) 2018D Noom, Inc.
 * @author Hubert
*/
var Api = {
  api: {},
  register: function register(key, method) {
    _lodash["default"].set(Api.api, key, method);
  },
  debugTimeout: function debugTimeout(timeout) {
    Api._timeout = timeout;
  },
  call: function call(requestKey, endpoint, data) {
    var request = new _ApiRequest["default"](requestKey);

    _ApiRequestsCollection["default"].insert(request);

    _ApiRequestsCollection["default"].emitChange();

    if (!_lodash["default"].isFunction(endpoint)) {
      throw "Unknown endpoint for [".concat(requestKey, "] api call.");
    }

    var promise = Api._timeout ? new Promise(function (resolve) {
      setTimeout(function () {
        resolve();
      }, Api._timeout);
    }).then(function () {
      return endpoint(data);
    }) : endpoint(data);
    return promise.then(function (x) {
      request.done();
      return x;
    })["catch"](function (e) {
      request.error();
      throw e;
    });
  },
  multi: function multi(requestKey) {
    var request = new _ApiRequest["default"](requestKey, {
      multi: true
    });

    _ApiRequestsCollection["default"].insert(request);

    _ApiRequestsCollection["default"].emitChange();

    return request;
  }
};

_DevTools["default"].expose({
  Api: Api
});

var _default = Api;
exports["default"] = _default;